module.exports = __webpack_public_path__ + "static/images/users-blue.b56fd1fd18ffc67bd85afea5d275b0d0.svg";